import React from 'react';

const FlowchartSVG = () => {
  return (
    <svg viewBox="0 0 1200 800" className="w-full max-w-5xl h-auto" xmlns="http://www.w3.org/2000/svg">
      {/* BMP Selection - Top Box */}
      <rect x="200" y="20" width="800" height="60" rx="8" fill="#4AA9D9" stroke="#3A8FC2" strokeWidth="2"/>
      <text x="600" y="55" fontSize="28" fontWeight="bold" fill="white" textAnchor="middle">BMP Selection</text>
      
      {/* Arrow down to split */}
      <line x1="600" y1="80" x2="600" y2="120" stroke="#4AA9D9" strokeWidth="3" markerEnd="url(#arrowhead)"/>
      
      {/* BMP Type Box - Left */}
      <rect x="380" y="120" width="200" height="50" rx="8" fill="#A4D9EE" stroke="#4AA9D9" strokeWidth="2"/>
      <text x="480" y="150" fontSize="20" fontWeight="bold" fill="#333" textAnchor="middle">BMP Type</text>
      
      <rect x="380" y="170" width="200" height="60" rx="4" fill="#D9D9D9" stroke="#999" strokeWidth="1"/>
      <text x="390" y="195" fontSize="16" fill="#333">• Bioretention</text>
      
      {/* Individual BMPs Box - Right */}
      <rect x="620" y="120" width="200" height="50" rx="8" fill="#A4D9EE" stroke="#4AA9D9" strokeWidth="2"/>
      <text x="720" y="150" fontSize="20" fontWeight="bold" fill="#333" textAnchor="middle">Individual BMPs</text>
      
      <rect x="620" y="170" width="200" height="60" rx="4" fill="#D9D9D9" stroke="#999" strokeWidth="1"/>
      <text x="630" y="195" fontSize="16" fill="#333">• Site ID</text>
      <text x="630" y="215" fontSize="16" fill="#333">• BMP ID</text>
      
      {/* Arrows from boxes down */}
      <line x1="480" y1="230" x2="480" y2="260" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="720" y1="230" x2="720" y2="260" stroke="#4AA9D9" strokeWidth="3"/>
      
      {/* Merge arrows */}
      <line x1="480" y1="260" x2="600" y2="260" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="720" y1="260" x2="600" y2="260" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="600" y1="260" x2="600" y2="300" stroke="#4AA9D9" strokeWidth="3" markerEnd="url(#arrowhead)"/>
      
      {/* Main horizontal line */}
      <line x1="100" y1="300" x2="1100" y2="300" stroke="#4AA9D9" strokeWidth="3"/>
      
      {/* Water Quality Box */}
      <rect x="85" y="310" width="220" height="50" rx="8" fill="#4AA9D9" stroke="#3A8FC2" strokeWidth="2"/>
      <text x="195" y="342" fontSize="22" fontWeight="bold" fill="white" textAnchor="middle">Water Quality</text>
      
      <rect x="85" y="360" width="220" height="80" rx="4" fill="#D9D9D9" stroke="#999" strokeWidth="1"/>
      <text x="95" y="385" fontSize="16" fill="#333">• Analyte 1</text>
      <text x="95" y="410" fontSize="16" fill="#333">• Analyte 2</text>
      <text x="95" y="430" fontSize="16" fill="#333">• ...</text>
      
      {/* Compare decision diamond - WQ */}
      <path d="M 195,470 L 255,510 L 195,550 L 135,510 Z" fill="#A4D9EE" stroke="#4AA9D9" strokeWidth="2"/>
      <text x="195" y="505" fontSize="14" fontWeight="bold" fill="#333" textAnchor="middle">Compare with</text>
      <text x="195" y="520" fontSize="14" fontWeight="bold" fill="#333" textAnchor="middle">other BMPs?</text>
      
      <line x1="195" y1="440" x2="195" y2="470" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="195" y1="550" x2="195" y2="580" stroke="#4AA9D9" strokeWidth="3" markerEnd="url(#arrowhead)"/>
      
      {/* Pollutant Treatment Box */}
      <rect x="80" y="580" width="160" height="70" rx="8" fill="white" stroke="#4AA9D9" strokeWidth="3"/>
      <text x="160" y="610" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Pollutant</text>
      <text x="160" y="632" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Treatment</text>
      
      {/* Performance Index Box - WQ */}
      <rect x="260" y="580" width="180" height="70" rx="8" fill="white" stroke="#4AA9D9" strokeWidth="3"/>
      <text x="350" y="610" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Performance</text>
      <text x="350" y="632" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Index</text>
      
      {/* Hydrology Box */}
      <rect x="523" y="310" width="210" height="50" rx="8" fill="#4AA9D9" stroke="#3A8FC2" strokeWidth="2"/>
      <text x="628" y="342" fontSize="22" fontWeight="bold" fill="white" textAnchor="middle">Hydrology</text>
      
      {/* Compare decision diamond - Hydro */}
      <path d="M 628,390 L 688,430 L 628,470 L 568,430 Z" fill="#A4D9EE" stroke="#4AA9D9" strokeWidth="2"/>
      <text x="628" y="425" fontSize="14" fontWeight="bold" fill="#333" textAnchor="middle">Compare with</text>
      <text x="628" y="440" fontSize="14" fontWeight="bold" fill="#333" textAnchor="middle">other BMPs?</text>
      
      <line x1="628" y1="360" x2="628" y2="390" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="628" y1="470" x2="628" y2="500" stroke="#4AA9D9" strokeWidth="3" markerEnd="url(#arrowhead)"/>
      
      {/* Flow & Volume Reduction Box */}
      <rect x="425" y="500" width="200" height="70" rx="8" fill="white" stroke="#4AA9D9" strokeWidth="3"/>
      <text x="525" y="530" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Flow & Volume</text>
      <text x="525" y="552" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Reduction</text>
      
      {/* Performance Index Box - Hydro */}
      <rect x="645" y="500" width="180" height="70" rx="8" fill="white" stroke="#4AA9D9" strokeWidth="3"/>
      <text x="735" y="530" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Performance</text>
      <text x="735" y="552" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Index</text>
      
      {/* Multi Parameter Index Box */}
      <rect x="893" y="310" width="280" height="50" rx="8" fill="#4AA9D9" stroke="#3A8FC2" strokeWidth="2"/>
      <text x="1033" y="342" fontSize="22" fontWeight="bold" fill="white" textAnchor="middle">Multi Parameter Index</text>
      
      {/* Compare decision diamond - MPI */}
      <path d="M 1033,390 L 1093,430 L 1033,470 L 973,430 Z" fill="#A4D9EE" stroke="#4AA9D9" strokeWidth="2"/>
      <text x="1033" y="425" fontSize="14" fontWeight="bold" fill="#333" textAnchor="middle">Compare with</text>
      <text x="1033" y="440" fontSize="14" fontWeight="bold" fill="#333" textAnchor="middle">other BMPs?</text>
      
      <line x1="1033" y1="360" x2="1033" y2="390" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="1033" y1="470" x2="1033" y2="500" stroke="#4AA9D9" strokeWidth="3" markerEnd="url(#arrowhead)"/>
      
      {/* Overall Performance Index Box */}
      <rect x="918" y="500" width="230" height="70" rx="8" fill="white" stroke="#4AA9D9" strokeWidth="3"/>
      <text x="1033" y="530" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Overall</text>
      <text x="1033" y="552" fontSize="18" fontWeight="bold" fill="#333" textAnchor="middle">Performance Index</text>
      
      {/* Connecting lines from boxes to bottom */}
      <line x1="350" y1="650" x2="350" y2="680" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="735" y1="570" x2="735" y2="680" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="1033" y1="570" x2="1033" y2="680" stroke="#4AA9D9" strokeWidth="3"/>
      
      {/* Horizontal merge line */}
      <line x1="350" y1="680" x2="600" y2="680" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="735" y1="680" x2="600" y2="680" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="1033" y1="680" x2="600" y2="680" stroke="#4AA9D9" strokeWidth="3"/>
      <line x1="600" y1="680" x2="600" y2="710" stroke="#4AA9D9" strokeWidth="3" markerEnd="url(#arrowhead)"/>
      
      {/* Download data Box */}
      <rect x="485" y="710" width="230" height="50" rx="8" fill="#4AA9D9" stroke="#3A8FC2" strokeWidth="2"/>
      <text x="600" y="742" fontSize="22" fontWeight="bold" fill="white" textAnchor="middle">Download data</text>
      
      {/* Arrow marker definition */}
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
          <polygon points="0 0, 10 3, 0 6" fill="#4AA9D9" />
        </marker>
      </defs>
    </svg>
  );
};

export default FlowchartSVG;
